<template>
  <div>
    <div class="mt-4">
      <v-card-title>
        <v-row class="py-2">
          <v-col lg="6" md="4" sm="2" class="col-8">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-4" v-on="on" fab dark small color="primary" @click="agregar()">
                  <v-icon small dark>fas fa-user-plus</v-icon>
                </v-btn>
              </template>
              <span>Agregar</span>
            </v-tooltip>
          </v-col>
          <v-spacer></v-spacer>
          <v-col lg="4" md="4" sm="4" class="col-12">
            <v-text-field
              class="px-4"
              v-model="search"
              append-icon=" fas fa-search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        class="border"
        multi-sort
        :mobile-breakpoint="0"
        :items-per-page="pagina"
        no-results-text="No se encontraron datos"
        no-data-text=""
      >
        <template v-slot:item.activo="{ item }">
          <v-icon color="red" small v-if="item.activo == 0">fas fa-times</v-icon>
          <v-icon color="green" small v-else-if="item.activo == 1">fas fa-check</v-icon>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmpleadosAsignadosLista',
  data: () => ({
    search: '',
    /*filtro: '',
    opciones: [
      { text: 'TODOS', value: '' },
      { text: 'HABILITADOS', value: '1' },
      { text: 'DESHABILITADOS', value: '0' }
    ], */
    dialog: false,
    nuevo: false,
    headers: [
      { text: 'nombres', value: 'nombres' },
      { text: 'idunidadcomedor', value: 'idunidadcomedor' },
      { text: 'sector', value: 'sector' },
      { text: 'bloque', value: 'bloque' },
      { text: 'campo', value: 'campo' },
      { text: 'etapa', value: 'etapa' },
      { text: 'comedor', value: 'comedor' },
      { text: 'activo', value: 'activo' }
    ],
    desserts: []
  }),
  computed: {
    pagina() {
      if (screen.width <= 600) return 5;
      else return 15;
    }
  },
  watch: {},
  methods: {
    async initialize() {},
    agregar() {
      this.$router.push({ path: '/comedor/asignacion/asignar' });
    },
    async seleccion(env) {
      await this.initialize(env);
    }
  },
  async mounted() {}
};
</script>
